export const environment = {
  production: false,
  apiAuth: 'https://devapi.ligapadla.pl/api/auth',
  apiUrl: 'https://devapi.ligapadla.pl/api/v1',
};
